const headers = {
  name: "Service category",
  navigate: {
    tabs: [
      {
        name: "Categories",
        path: "/app/services/categories",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
